import 'core-js/stable';
import 'vite/modulepreload-polyfill';

// NodeList.forEach is not available in IE
if (window.NodeList && !NodeList.prototype.forEach) {
  // @ts-ignore
  NodeList.prototype.forEach = Array.prototype.forEach;
}

if (!window.setImmediate) {
  // @ts-ignore
  window.setImmediate = (fn) => {
    setTimeout(fn, 0);
  };
}
